<style lang="less" scoped>
.dhxwList{position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;}
.mains{position: relative;width: 800px;display: flex;}
.first{display: flex;flex-direction: column;width: 780px;margin-right: 20px;}
p{text-align:left;}
.title{line-height: 50px;display: flex; flex-direction: column;margin-top: 10px;
  span{font-size: 36px;margin-left: 60px;}
  i{width: 760px; height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
}
.subtitle{font-size: 25px;font-weight: 600; margin-left: 60px;margin-top: 0px;}
.list{margin-left: 60px;}
.sub{margin-left: 60px;color: #3c77bb;font-size: 20px;}
</style>

<template>
  <div class="dhxwList">
    <div class="mains">
      <div class="first">
        <p class="title"><span>2021展览会概况</span><i></i></p>
        <p class="sub">主办单位</p>
        <p class="list">广西壮族自治区人民政府</p>
        <p class="list">中华人民共和国自然资源部</p>
        <p class="sub">承办单位</p>
        <p class="list">广西壮族自治区自然资源厅</p>
        <p class="list">自然资源部国际合作司</p>
        <p class="list">中国地质调查局</p>
        <p class="list">广西壮族自治区地质矿产勘查开发局</p>
        <p class="sub">协办单位</p>
        <p class="list">中国自然资源经济研究院</p>
        <p class="list">自然资源部国土卫星遥感应用中心</p>
        <p class="list">中国地质博物馆</p>
        <p class="list">中国矿业联合会</p>
        <p class="list">中国黄金协会</p>
        <p class="list">中国地质调查局国际矿业研究中心</p>
        <p class="list">南方石山地区矿山地质环境修复工程技术创新中心</p>
        <p class="list">自然资源广西卫星应用技术中心</p>
        <p class="list">中铝广西有色稀土开发有限公司</p>
        <p class="list">广西国际博览事务局</p>
        <p class="list">桂林理工大学</p>
        <p class="sub">外方协办单位</p>
        <p class="list">中国—东盟中心</p>
        <p class="list">联合国教科文组织国际岩溶研究中心</p>
        <p class="list">东盟国家矿业协会联合会</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data()
  {
    return {
      list: []
    }
  },
  created()
  {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Ltzlhgk.vue